import React, {useState} from "react";
import ApiFunctions from "../Api/ApiFunctions";
import {ASSETSBASE} from "../../config/Pfalzmarkt.config";

export default function Maschinenboerse() {
    const [machines, setMachines] = useState([]);

    function mapData(data) {
        const machinesList = [];

        for (const machine of data) {
            machinesList.push({file: machine.file});
        }
        setMachines(machinesList);
    }

    return (
        <>
            <ApiFunctions url="api/maschinenboerse" mappingFunction={mapData}/>
            <table className="table">
                <thead>
                <tr>
                    <th scope="col">Dateiname</th>
                </tr>
                </thead>
                <tbody>
                {machines.map((machine) => (
                    <tr>
                        <td><a href={ASSETSBASE + 'maschinenboerse/' + machine.file} target="_blanc">{machine.file}</a>
                        </td>
                    </tr>
                ))
                }
                <tr>

                </tr>
                </tbody>
            </table>
        </>
    )
}